module.exports = __webpack_public_path__ + "img/follow-bg.10f81c0f.png";